import { LayoutType, withLayout } from 'src/hocs/withLayout'

import { SurvivorProfile } from './survivorProfile'

const WrappedSurvivorProfile = withLayout(LayoutType.NoPadding, SurvivorProfile)

export { WrappedSurvivorProfile as SurvivorProfile }
